module.exports = __webpack_public_path__ + "img/Nathan-Lule.b42f0384.jpg";